var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconSearch = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6332 19.9631L16.1574 14.4852C17.1389 13.1465 17.6648 11.528 17.6574 9.86801C17.6387 5.53491 14.134 2.02511 9.80092 2.00008C7.7273 1.9907 5.73606 2.81102 4.27078 4.27832C2.8055 5.74561 1.98791 7.73798 2.00014 9.81158C2.01886 14.1451 5.52388 17.6552 9.85735 17.6802C11.5241 17.6874 13.1485 17.1555 14.4881 16.1638L14.4938 16.1595L19.9646 21.6331C20.2604 21.9434 20.7011 22.069 21.116 21.9613C21.531 21.8535 21.8549 21.5293 21.9623 21.1143C22.0697 20.6993 21.9437 20.2586 21.6332 19.9631ZM9.85164 16.1115C6.38506 16.0916 3.58109 13.2838 3.56587 9.81717C3.55651 8.1585 4.21064 6.56492 5.38264 5.39118C6.55464 4.21743 8.14725 3.56093 9.80593 3.56782C13.2725 3.58776 16.0765 6.39556 16.0917 9.86217C16.1011 11.5208 15.4469 13.1144 14.2749 14.2882C13.1029 15.4619 11.5103 16.1184 9.85164 16.1115Z",
    fill: "#878793"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconSearch);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-search.61820b77fcd81a42f6b4703dc2dcd511.svg";